<div id="couponList" class="ya-typography" (swiperight)="navigateBack()">
  <ya-subheader [hasContent]="true" [disableNavigateBack]="true" (onNavigateBackClick)="navigateBack()">
    <div class="header-action-item">
      <a @plopInOut matRipple matRippleCentered="true" (click)="openFilterDialog()" matBadge="!" matBadgeSize="small"
        [matBadgeHidden]="locationFilterIds.length>0" class="header-tools-wrapper main-header-account">
        <div class="inline-icon hyp-filter-svg" inlineSVG="shop-icons.svg#ya-hypersoft-standort"></div>
        <ng-container *ngIf="locationFilterIds.length>0">
          <div class="checkmark-container">
            <div class="inline-icon onlile-account-checkmark" inlineSVG="shop-icons.svg#ya-hypersoft-check-voll"></div>
          </div>
        </ng-container>
      </a>
    </div>
  </ya-subheader>
  <div [@couponButtonEntering]="isLoaded" class="ya-page-content ya-page-content--webshop">
    <ng-container *ngIf="hasData; then pageTemplate else emptyTemplate"></ng-container>
    <ng-template #pageTemplate>
      <div class="coupon-tabs">
        <mat-tab-group mat-stretch-tabs dynamicHeight="true" animationDuration="20ms">
          <mat-tab label="news">
            <div class="ya-page-content ya-page-content--padding ya-page-content--webshop">
              <div class="ya-item-list-container">
                <ng-container *ngFor="let coupon of couponList; trackBy: trackCouponById">
                  <div class="ya-content-item coupon-item news-button"
                    [class.coupon-item--disabled]="coupon.isRedeemed || isCouponInCart(coupon.id)" a11y_Button
                    [attr.aria-label]="couponDetailAriaLabel" (click)="couponClickHandler(coupon)">
                    <div class="left">
                      <div class="coupon-date-wrapper ya-caption">
                        <div class="coupon-detail-like">
                          <ya-favoritebutton [contentType]="contentType.Coupon" [likeStatus]="coupon.like"
                            [modelId]="coupon.id" [customClass]="'custom-favorite-button'">
                          </ya-favoritebutton>
                        </div>
                      </div>
                      <div class="aspect-ratio-box">
                        <div class="aspect-ratio-box-inside">
                          <ng-container *ngIf="!coupon.anonym_code">
                            <div class="member-icon">
                              <span langkey="phCoupon_Members"></span>
                              <div class="inline-icon hyp-filter-svg"
                                inlineSVG="shop-icons.svg#ya-hypersoft-user-single">
                              </div>
                            </div>
                          </ng-container>
                          <div class="aspect-ration-img-box">
                            <img class="ya_image" [src]="coupon.image_photo" alt="" />
                          </div>
                        </div>
                      </div>
                      <div class="coupon-footer-info">
                        <div *ngIf="coupon.startDate && coupon.endDate" class="coupon-content-date-container">
                          <div *ngIf="compareDateBefore(coupon)">
                            <span langkey="phCoupon_Expires_On"></span><span
                              class="coupondate">{{coupon.endDate}}</span><span
                              langkey="phCoupon_Expires_On_End"></span>.
                          </div>
                          <div *ngIf="compareDateEqual(coupon)">
                            <span langkey="phCoupon_Expires_Today"></span>
                          </div>
                        </div>
                        <ng-container *ngIf="coupon.isRedeemed">
                          <div class="coupon-state coupon-state--redeemed" data-testid="coupon-state-redeemed">
                            <div class="inline-icon" inlineSVG="shop-icons.svg#ya-done"></div>
                            <span langkey="phCoupon_State_AlreadyRedeemed"></span>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="!coupon.isRedeemed && isCouponInCart(coupon.id)">
                          <div class="coupon-state coupon-state--in-cart" data-testid="coupon-state-in-cart">
                            <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-warenkorp"></div>
                            <span langkey="phCoupon_State_InCart"></span>
                          </div>
                        </ng-container>
                      </div>
                      <div class="coupon-content">
                        <div class="coupon-content-wrapper">
                          <h2 class="title ya-text-truncate" style="-webkit-box-orient: vertical;">
                            {{coupon.label}}
                          </h2>
                          <ng-container *ngIf="!isSmallView">
                            <div class="coupon-text-container">
                              <p class="content-text" [innerHTML]="coupon.text"></p>
                              <div class="inline-icon hyp-filter-svg" inlineSVG="shop-icons.svg#ya-hypersoft-coupon">
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </ng-template>
    <ng-template #emptyTemplate>
      <ya-emptypage></ya-emptypage>
    </ng-template>
  </div>
</div>